import React from 'react';
import { Modal } from './ui/Modal';
import { Button } from './ui/Button';

const ConfirmModal = ({ title, message, onConfirm, onCancel, confirmLabel = 'Удалить', danger = false }) => (
  <Modal
    open
    onClose={onCancel}
    title={title}
    size="sm"
    footer={
      <>
        <Button variant="ghost" onClick={onCancel}>
          Отмена
        </Button>
        <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </>
    }
  >
    <div className="flex items-start gap-lg">
      <div
        className={`flex items-center justify-center w-9 h-9 rounded-md shrink-0 ${
          danger ? 'bg-destructive-soft text-destructive' : 'bg-primary-soft text-primary'
        }`}
      >
        <i className={`bi ${danger ? 'bi-exclamation-triangle' : 'bi-question-circle'}`} aria-hidden="true" />
      </div>
      <p className="text-body-sm text-text pt-md">{message}</p>
    </div>
  </Modal>
);

export default ConfirmModal;
